// extracted by mini-css-extract-plugin
export var infoRow = "_qw-2";
export var labelContainer = "_qw-0";
export var rightInfo = "_qw-1";